import React from "react";
import { Link } from "react-router-dom";
import "../styles/applynow.css";
import Footer from "../components/Footer";

export default function Applynow() {
    return (
        <>
            <section className="coming-soon">
                <div className="overlay"></div>
                <div className="coming-content">
                    <h1 className="coming-title">🚀 Applications Opening Soon</h1>
                    <p className="coming-subtext">
                        We’re preparing something exciting for you. Stay tuned for the official launch of our admissions portal.
                    </p>

                    {/* Countdown timer look (static for now) */}
                    <div className="countdown">
                        <div>
                            <strong>30</strong>
                            <span>Days</span>
                        </div>
                        <div>
                            <strong>12</strong>
                            <span>Hours</span>
                        </div>
                        <div>
                            <strong>45</strong>
                            <span>Minutes</span>
                        </div>
                    </div>

                    {/* Button back to home */}
                    <Link to="/" className="back-home">
                        ⬅ Back to Home
                    </Link>
                </div>
            </section>
            <Footer />
        </>
    );
}
